<script setup lang="ts">

const emit = defineEmits<{
	(e: 'onClose'): void
	(e: 'onTokenGateSuccess'): void
	(e: 'onTokenGateFail'): void
}>();

const props = defineProps({
	eventId: {
		type: Number as PropType<number | null>,
		required: true,
	},
	orderId: {
		type: String,
		required: true,
	},
	isOpen: {
		type: Boolean,
		default: false,
	},
});

const router = useRouter();
const attendeeStore = useAttendeeStore();
const checkoutStore = useCheckoutStore();

const isEnablePolling = ref(false);

const orderId = computed(() => props.orderId || null);
const eventId = computed(() => props.eventId || null);

async function handlePollingCallbackSuccess() {
	// Fetch for order details after successfully polling an order status
	if (checkoutStore.salesId && eventId.value) {
		await attendeeStore.getOrder(eventId.value, checkoutStore.salesId);
	}
}

const { orderStatus } = usePollingOrderStatus(
	orderId,
	isEnablePolling,
	handlePollingCallbackSuccess,
);

watch(() => props.isOpen, async (isOpen) => {
	if (isOpen) {
		// Remove query string
		router.push({ query: {} });
		isEnablePolling.value = true;
	} else {
		isEnablePolling.value = false;
	}
});

watch(orderStatus, (newOrderStatus) => {
	if (!isEnablePolling.value) {
		return;
	}

	if (newOrderStatus === POLLING_ORDER_STATUS.SUCCESS) {
		emit('onTokenGateSuccess');
	} else if (newOrderStatus === POLLING_ORDER_STATUS.FAIL) {
		emit('onTokenGateFail');
	}
});
</script>
<template>
  <BaseSideDrawer
    class="drawer-full-content"
    :is-open="isOpen"
    :is-closable="false"
    persistent
  >
    <template #content>
      <OrderProcessing>
        Your order is processing
      </OrderProcessing>
    </template>
  </BaseSideDrawer>
</template>
<style scoped lang="scss">
.drawer-full-content {
  :deep(.drawer-content.--extend) {
    height: 100%;
  }
}
</style>